import loginApi from '@/api/loginApi'

const SET_USER = 'setUser'
const CHECK_LOGIN_STATUS = 'checkLoginStatus'
const REFRESH_USER_INFO = 'refreshUserInfo'
const EXIT = 'exit'

const state = {
  userInfo: {},
  loginStatus: false
}

const getters = {
  resCateList: state => {
    const codeList = []
    if (state.userInfo && state.userInfo.resource_category_list) {
      state.userInfo.resource_category_list.forEach(item => {
        codeList.push(item.code)
      })
    }
    return codeList
  },
  hasResCate: (state, getters) => code => {
    if (state.userInfo.is_admin === 1) {
      return true
    }
    return getters.resCateList.indexOf(code) !== -1
  },
  resList: state => {
    const codeList = []
    if (state.userInfo && state.userInfo.resource_category_list) {
      state.userInfo.resource_category_list.forEach(item => {
        if (item.resource_list) {
          item.resource_list.forEach(res => {
            codeList.push(res.code)
          })
        }
      })
    }
    return codeList
  },
  hasRes: (state, getters) => code => {
    if (state.userInfo.is_admin === 1) {
      return true
    }
    return getters.resList.indexOf(code) !== -1
  },
  isAdmin: state => state.userInfo.is_admin === 1
}

const mutations = {
  [SET_USER] (state, userInfo) {
    // Set user info
    state.userInfo = userInfo

    // Save user info to localStorage
    // userInfo
    localStorage.setItem('user_info', JSON.stringify(userInfo))
  },
  [CHECK_LOGIN_STATUS] (state) {
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    if (userInfo === null) {
      state.loginStatus = false
      return
    }

    const now = parseInt(new Date().getTime() / 1000)
    if (now < userInfo.exp) {
      state.loginStatus = true
      return
    }
    state.loginStatus = false
  },
  [REFRESH_USER_INFO] (state) {
    const userInfo = JSON.parse(localStorage.getItem('user_info'))
    state.userInfo = userInfo === null ? {} : userInfo
  },
  [EXIT] (state) {
    state.userInfo = {}
    localStorage.removeItem('user_info')
  }
}

const actions = {
  register ({ commit }, data) {
    return new Promise((resolve, reject) => {
      loginApi.register(data.username, data.password).then(res => {
        if (res && res.rcode === 0) {
          resolve(res)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  },
  login ({ commit }, data) {
    return new Promise((resolve, reject) => {
      loginApi.login(data.username, data.password).then(res => {
        if (res && res.rcode === 0) {
          commit(SET_USER, res.data)
          resolve(res)
        } else {
          resolve(false)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export {
  CHECK_LOGIN_STATUS,
  REFRESH_USER_INFO
}



// WEBPACK FOOTER //
// ./src/store/modules/op_user.js